import { routeAccess } from 'app/access';
import RequireAuth from 'app/components/RequireAuth';
import { lazy } from 'react';
import { Route } from 'react-router';

const XLedgerTransfersRoute = lazy(() => import('./x-ledger-transfers/XledgerTransfersRoute'));
const XledgerTransferRoute = lazy(() => import('./x-ledger-transfers/XledgerTransferRoute'));

export default [
  <Route
    key="xledger"
    path="/xledger"
    element={
      <RequireAuth {...routeAccess.monitoring}>
        <XLedgerTransfersRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="xledger-detail"
    path="/xledger/:id"
    element={
      <RequireAuth {...routeAccess.monitoring}>
        <XledgerTransferRoute />
      </RequireAuth>
    }
  />,
];
